interface Props {
  x: number;
  y: number;
  onDelete: () => void;
  onClose: () => void;
}

export default function RouteContextMenu({ x, y, onDelete, onClose }: Props) {
  return (
    <>
      <button
        type="button"
        className="fixed inset-0 z-40 cursor-default"
        aria-label="Close menu"
        onClick={onClose}
      />
      <div
        className="fixed z-50 min-w-[140px] rounded-lg border border-border bg-surface-raised py-1 shadow-lg"
        style={{ left: x, top: y }}
      >
        <button
          type="button"
          className="block w-full px-3 py-2 text-left text-sm text-danger hover:bg-surface-overlay"
          onClick={() => {
            onDelete();
            onClose();
          }}
        >
          Delete route
        </button>
      </div>
    </>
  );
}
